export const PRICE_FIELD_CONTENT = {
    CURRENCY_SUFFIX: "zł",
    UNLIMITED_LABEL: "bez limitu"
} as const;
export const PRICE_FIELD_CONTENT = {
    CURRENCY_SUFFIX: "zł",
    UNLIMITED_LABEL: "bez limitu"
} as const;
